import React from 'react'
import "./Footer.css"
import{Link} from 'react-router-dom'
function Footer() {
  return (
    <div className='full-list'>
        <>
        <h2 className='dev-sid'>Developed By Siddharth Chandrakar</h2>
        </>  
    </div>
  )
}

export default Footer
